/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.sherpa.activities.tenant.controllers', [
  'ui.router',
  'acme.view.application.sherpa.activities.b2b.controllers',
  'acme.view.application.sherpa.activities.b2c.controllers'
])

.controller('SherpaActivitiesTenantController', ['$scope', '$state', function($scope, $state) {

    $scope.sherpaActivitiesTenant = {
      tab: 'b2b',
      init: function () {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Activity'
        });

        if ($state.params && $state.params.list) {
          switch($state.params.list) {
            case 'visitors':
            // falls through
            case 'tenants':
              this.tab = $state.params.list;
              break;
          }
        }
      },
      setTab: function(tab) {
        this.tab = tab;
      }
    };
    $scope.sherpaActivitiesTenant.init();
}]);